import { useEffect, useMemo, useState } from 'react';
import { ParsedQuery } from 'query-string';
import { useFilters } from './useFilters';

export const useCardRoutes = () => {
  const {applyFilters} = useFilters();
  const [filtersSaver, setFiltersSaver] = useState<ParsedQuery | null>(null);
  const [cardsHistory, setCardsHistory] = useState<ParsedQuery[]>([]);
  const [freezeCardHistory, setFreezeCardsHistory] = useState(false);
  const {currentFilters} = useFilters();

  const allFiltersClearedObj = {
    pageNo: null,
    perPage: null,
    addTeam: null,
    compare: null,
    compareSort: null,
    activeSection: null,
    surveyReport: null,
    prm: null,
    riskAnalysis: null,
    predictiveStates: null,
    performers: null,
    categories: null,
    card: null,
  };

  const isBackButtonVisible = useMemo(() => {
    return cardsHistory.length > 0;
  }, [cardsHistory]);

  const goBackToCard = () => {
    setFreezeCardsHistory(true);
    const cardsHistoryCopy = [...cardsHistory];
    const lastCardFilters = cardsHistoryCopy.pop();
    setCardsHistory(cardsHistoryCopy);
    if (lastCardFilters) {
      applyFilters(lastCardFilters as Record<string, string | null | undefined>);
    }
  };

  useEffect(() => {
    if(freezeCardHistory){
      if(cardsHistory.length === 0){
        setFiltersSaver(null);
      }
      return setFreezeCardsHistory(false);
    }
    if(filtersSaver?.card !== currentFilters?.card && !freezeCardHistory) {
      const lastCardFilters = {...allFiltersClearedObj,...filtersSaver };
      const cardsArrNewState = [...cardsHistory, lastCardFilters];
      setCardsHistory(cardsArrNewState);
    }
    setFiltersSaver(currentFilters);
  }, [currentFilters, filtersSaver]);

  return {
    allFiltersClearedObj,
    isBackButtonVisible,
    goBackToCard,
  };
};
